var React = require("react");

var Molecule = require("./molecule.jsx").molecule;

var Separator = React.createClass({
    displayName: "Separator",

    propTypes: {
        // TODO(colin): figure out and add shape.
        data: React.PropTypes.any,
        index: React.PropTypes.number
    },

    componentDidMount: function componentDidMount() {
        this.drawArrow();
    },

    componentDidUpdate: function componentDidUpdate() {
        this.drawArrow();
    },

    arrowLength: 100,

    drawArrow: function drawArrow() {
        var canvas = this.refs["arrowCanvas" + this.props.index];
        var ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        var path = new Path2D();
        ctx.strokeStyle = "rgb(0,0,0)";
        ctx.lineWidth = 1.2;
        ctx.lineCap = "round";
        var offset = 5;
        path.moveTo(offset, canvas.height / 2);
        path.lineTo(canvas.width - offset, canvas.height / 2);
        path.moveTo(canvas.width - 2 * offset, canvas.height / 2 - offset);
        path.lineTo(canvas.width - offset, canvas.height / 2);
        path.moveTo(canvas.width - 2 * offset, canvas.height / 2 + offset);
        path.lineTo(canvas.width - offset, canvas.height / 2);
        ctx.stroke(path);
    },

    render: function render() {
        return React.createElement(
            "div",
            { className: "arrow-container" },
            React.createElement(
                "div",
                { className: "above-text" },
                this.props.data.topText
            ),
            React.createElement(
                "canvas",
                {
                    height: "30",
                    id: "arrowCanvas" + this.props.index,
                    ref: "arrowCanvas" + this.props.index,
                    width: this.arrowLength
                },
                "Reaction arrow pointing to the right."
            ),
            React.createElement(
                "div",
                { className: "below-text" },
                this.props.data.bottomText
            )
        );
    }
});

var ReactionDiagramWidget = React.createClass({
    displayName: "ReactionDiagramWidget",

    propTypes: {
        // TODO(colin): at the moment, these must be arrays of two elements;
        // we're limited to a single reaction step.  At some point, add support
        // for more steps in the reaction.
        rotationAngle: React.PropTypes.arrayOf(React.PropTypes.number),
        separators: React.PropTypes.arrayOf(React.PropTypes.object),
        smiles: React.PropTypes.arrayOf(React.PropTypes.string),
        widgetId: React.PropTypes.string
    },

    getDefaultProps: function getDefaultProps() {
        return { smiles: [], rotationAngle: [], separators: [] };
    },

    simpleValidate: function simpleValidate() {
        return { type: "points", earned: 0, total: 0, message: null };
    },

    getUserInput: function getUserInput() {
        return [];
    },

    validate: function validate(state, rubric) {
        // TODO(colin): this appears to be part of the perseus interface.
        // Figure out if there's a more appropriate value to return.
        return {
            type: "points",
            earned: 0,
            total: 0,
            message: null
        };
    },

    focus: function focus() {
        return true;
    },

    render: function render() {
        var _this = this;

        return React.createElement(
            "div",
            { className: "reaction", ref: "reaction" },
            this.props.smiles.map(function (s, i) {
                var id = _this.props.widgetId + "-" + i;
                return React.createElement(
                    "div",
                    { key: id, className: "molecule-container" },
                    React.createElement(Molecule, {
                        id: id,
                        rotationAngle: _this.props.rotationAngle[i],
                        smiles: s
                    }),
                    i === _this.props.smiles.length - 1 ? null : React.createElement(Separator, {
                        data: _this.props.separators[i],
                        index: i
                    })
                );
            })
        );
    }
});

module.exports = {
    name: "reaction-diagram",
    displayName: "Chemical reaction",
    hidden: true,
    widget: ReactionDiagramWidget
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/reaction-diagram.jsx
 ** module id = 142
 ** module chunks = 0 1
 **/